/**
 * Slice del RC 198 Seriales de la importación (Diego 2026-10-13): pantalla, recuento con RECO, plantilla
 * predeterminada (descargar y cargar), captura manual, quitar seriales, discrepancias y exportación.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-08-18
 */

import { apiSlice } from "../../../apiSlice";

const headers = { Modulecima: "Modimpxx" };
const invalida = ["Serialdo", "keyResultImpo", "KeyResults"];

export const serialdoApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getSerialdo: builder.query({
      query: (parameters) => ({ url: `/Modimpxx/Documexx/Serialdo/${parameters.DOCNROXX}`, method: "GET", headers }),
      providesTags: ["Serialdo"],
    }),
    reevaluarSerialdo: builder.mutation({
      query: ({ DOCNROXX }) => ({ url: `/Modimpxx/Documexx/Serialdo/reevaluar/${DOCNROXX}`, method: "POST", body: {}, headers }),
      invalidatesTags: invalida,
    }),
    plantillaSerialdo: builder.query({
      query: (DOCNROXX) => ({ url: `/Modimpxx/Documexx/Serialdo/plantilla/${DOCNROXX}`, method: "GET", headers, responseHandler: (response) => response.blob(), cache: "no-cache" }),
    }),
    buscarSerialdo: builder.query({
      query: ({ DOCNROXX, texto = "", pagina = 1, por_pagina = 100 }) => ({
        url: `/Modimpxx/Documexx/Serialdo/buscar/${DOCNROXX}?texto=${encodeURIComponent(texto)}&pagina=${pagina}&por_pagina=${por_pagina}`,
        method: "GET",
        headers,
      }),
      providesTags: ["Serialdo"],
    }),
    exportarSerialdo: builder.query({
      query: (DOCNROXX) => ({ url: `/Modimpxx/Documexx/Serialdo/exportar/${DOCNROXX}`, method: "GET", headers, responseHandler: (response) => response.blob(), cache: "no-cache" }),
    }),
    cargarSerialdo: builder.mutation({
      query: ({ DOCNROXX, file }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("DOCNROXX", DOCNROXX);
        return { url: `/Modimpxx/Documexx/Serialdo/cargar`, method: "POST", body: formData, headers: { ...headers, Accept: "application/json" } };
      },
      invalidatesTags: invalida,
    }),
    guardarSerialdo: builder.mutation({
      query: (parameters) => ({ url: `/Modimpxx/Documexx/Serialdo/guardar`, method: "POST", body: parameters, headers }),
      invalidatesTags: invalida,
    }),
    quitarSerialdo: builder.mutation({
      query: (parameters) => ({ url: `/Modimpxx/Documexx/Serialdo/quitar`, method: "POST", body: parameters, headers }),
      invalidatesTags: invalida,
    }),
    complementarSerialdo: builder.mutation({
      query: (parameters) => ({ url: `/Modimpxx/Documexx/Serialdo/complementar`, method: "POST", body: parameters, headers }),
      invalidatesTags: invalida,
    }),
    resolverDiscrepanciaSerialdo: builder.mutation({
      query: (parameters) => ({ url: `/Modimpxx/Documexx/Serialdo/resolverDiscrepancia`, method: "POST", body: parameters, headers }),
      invalidatesTags: invalida,
    }),
  }),
});

export const {
  useGetSerialdoQuery,
  useBuscarSerialdoQuery,
  useReevaluarSerialdoMutation,
  useLazyPlantillaSerialdoQuery,
  useLazyExportarSerialdoQuery,
  useCargarSerialdoMutation,
  useGuardarSerialdoMutation,
  useQuitarSerialdoMutation,
  useComplementarSerialdoMutation,
  useResolverDiscrepanciaSerialdoMutation,
} = serialdoApiSlice;
